import { render, staticRenderFns } from "./signCommunity.vue?vue&type=template&id=ba345144&scoped=true&"
import script from "./signCommunity.vue?vue&type=script&lang=js&"
export * from "./signCommunity.vue?vue&type=script&lang=js&"
import style0 from "./signCommunity.vue?vue&type=style&index=0&id=ba345144&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba345144",
  null
  
)

export default component.exports